import { cn } from "@/lib/cn";
import { TONE, type Tone } from "./tones";
import { Card } from "./Card";

type Props = {
  label: string;
  value?: string | number | null;
  sub?: string;
  pending?: boolean;
  /** 라벨 앞 색점 톤 — 지정 시 선행 색점 렌더 */
  dot?: Tone;
  /** 증감 배지(%p/%/명 등). 양수=상승(초록), 음수=하락(빨강) */
  delta?: number | null;
  /** 증감 배지 단위 접미사 (기본 %) */
  deltaUnit?: string;
  className?: string;
};

/** 대시보드/목록 상단 KPI 카드. pending=집계 준비 중. */
export function StatCard({
  label,
  value,
  sub,
  pending,
  dot,
  delta,
  deltaUnit = "%",
  className,
}: Props) {
  return (
    <Card className={cn("p-5", className)}>
      <p className="flex items-center gap-1.5 text-sm text-muted">
        {dot && (
          <span
            className="inline-block h-2 w-2 shrink-0 rounded-full"
            style={{ background: TONE[dot].dot }}
          />
        )}
        {label}
      </p>
      {pending ? (
        <p className="mt-3 text-sm" style={{ color: "var(--faint)" }}>
          집계 준비 중
        </p>
      ) : (
        <p className="mt-2 text-[26px] font-bold text-ink">{value ?? "—"}</p>
      )}
      {delta != null && !pending && (
        <span
          className="mt-2 inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 text-xs font-semibold"
          style={
            delta >= 0
              ? { background: "var(--primary-soft)", color: "var(--primary)" }
              : { background: "var(--danger-soft)", color: "var(--danger)" }
          }
        >
          {delta >= 0 ? "▲" : "▼"} {Math.abs(delta)}
          {deltaUnit}
        </span>
      )}
      {sub && !pending && <p className="mt-1 text-xs text-muted">{sub}</p>}
    </Card>
  );
}
